import React from 'react';
import Reflux from 'reflux';
import {hashHistory, withRouter} from 'react-router';
import {Form, Button, message, Input, Avatar, Upload, Select, Collapse, Checkbox} from 'antd';
import {DmsTab, TableView, FilterBox} from 'Components';
import {openNotice, APIS} from 'Utils';
import config from '../../utils/config';
import {fetchProfile, updateProfile, saveImg} from '../../service/profile';
import {modifyPhone, modifyPassword} from '../../service/home';
import EditBindingTel from './editBindingTel';
import EditPassword from './editPassword';

const FormItem = Form.Item;
const Option = Select.Option;
const Panel = Collapse.Panel;
const CheckboxGroup = Checkbox.Group;

class ProfileInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['个人信息'],
            visible: false,
            visible2: false,
            disabledFlag: true,
            editMode: false,
            headImgUrl: '',
            showUploadList: true,
            userData: JSON.parse(window.localStorage.getItem('login_user_information')) || {},
            profile: {}
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.showEditTelModal = this.showEditTelModal.bind(this);
        this.editTelModalHandleOk = this.editTelModalHandleOk.bind(this);
        this.editTelModalHandleCancel = this.editTelModalHandleCancel.bind(this);
        this.showEditPasswordModal = this.showEditPasswordModal.bind(this);
        this.editPasswordModalHandleOk = this.editPasswordModalHandleOk.bind(this);
        this.editPasswordModalHandleCancel = this.editPasswordModalHandleCancel.bind(this);

        this.edit = this.edit.bind(this);
        this.save = this.save.bind(this);
        this.back = this.back.bind(this);
    }

    handleSubmit() {
        // console.log('aaaaaaaaaaaaaaaaa');
    }

    edit() {
        this.setState({
            disabledFlag: false,
            editMode: true
        });
    }

    // 保存编辑个人信息
    save = () => {
        const {getFieldsValue} = this.props.form;
        const {code, userName} = this.state.userData;
        const {id, account} = this.state.profile;
        const {headImgUrl} = this.state;
        var _obj = getFieldsValue(['tel', 'email', 'amountDecimalPlace', 'countDecimalPlace', 'priceDecimalPlace', 'orderMultiLine', 'orderType', 'payType', 'sortRules']);
        // _obj.code = code;
        _obj.name = userName;
        _obj.account = account;
        _obj.id = id;
        _obj.sortRules = _obj.sortRules.toString();
        updateProfile(_obj).then(result => {
            if (result && result.code == 200) {
                openNotice('success', '保存成功');
                this.setState({
                    disabledFlag: true,
                    editMode: false
                });
            } else {
                openNotice('error', '保存失败', (result && result.message) ? result.message : '');
            }
        });
        saveImg({
            id,
            imgUrl: headImgUrl
        }).then(result => {
            if (result && result.code !== 200) {
                openNotice('error', '保存失败', (result && result.message) ? result.message : '');
            }
        });
    }

    back() {
        this.setState({
            disabledFlag: true,
            editMode: false
        });
    }

    showEditTelModal() {
        this.setState({
            visible: true
        });
    }

    editTelModalHandleOk = (options) => {
        modifyPhone({
            oldPhone: this.state.profile.phone,
            phone: options.newTel,
            code: options.verifyCode
        }).then(result => {
            if (result && result.code == 200) {
                this.setState({
                    visible: false
                });
                openNotice('success', '修改绑定手机号码成功', (result && result.message) ? result.message : '');
                this.getProfile();
            } else {
                openNotice('error', '数据获取失败', (result && result.message) ? result.message : '');
            }
        });
    };

    editTelModalHandleCancel = (e) => {
        this.setState({
            visible: false
        });
    }

    showEditPasswordModal() {
        this.setState({
            visible2: true
        });
    }

    editPasswordModalHandleOk = (options) => {
        modifyPassword({
            oldPassword: options.originPwd.toUpperCase(),
            newPassword: options.newPwd.toUpperCase(),
        }).then(result => {
            if (result && result.code == 200) {
                this.setState({
                    visible2: false
                });
                openNotice('success', '修改密码成功', (result && result.message) ? result.message : '');
            } else {
                openNotice('error', '数据获取失败', (result && result.message) ? result.message : '');
            }
        });
    };

    editPasswordModalHandleCancel = (e) => {
        this.setState({
            visible2: false
        });
    }

    componentDidMount() {
        this.getProfile();
    }

    getProfile = () => {
        fetchProfile().then(result => {
            if (result && result.code == 200) {
                this.setState({
                    profile: result.data,
                    headImgUrl: result.data.imgUrl
                }, () => {
                    this.props.form.setFieldsValue({
                        tel: this.state.profile.tel,
                        email: this.state.profile.email,
                        amountDecimalPlace: this.state.profile.amountDecimalPlace,
                        priceDecimalPlace: this.state.profile.priceDecimalPlace,
                        countDecimalPlace: this.state.profile.countDecimalPlace,
                        payType: this.state.profile.payType,
                        orderType: this.state.profile.orderType ? this.state.profile.orderType.toString() : '',
                        sortRules: this.state.profile.sortRules ? this.state.profile.sortRules.split(',') : ''
                    })
                });
            } else {
                openNotice('error', '数据获取失败', (result && result.message) ? result.message : '');
            }
        });
    };

    render() {
        const self = this;
        const {opts, disabledFlag, editMode, headImgUrl, visible, visible2, profile, showUploadList} = this.state;
        const formItemLayout = {
            labelCol: {
                xs: {span: 24},
                sm: {span: 2}
            },
            wrapperCol: {
                xs: {span: 24},
                sm: {span: 4, offset: 1}
            }
        };

        const {getFieldDecorator} = this.props.form;

        const options = [
            {label: '销量排序', value: '1'},
            {label: '库存属性排序', value: '2'}
        ];

        const props = {
            name: 'file',
            action: APIS.upload,
            showUploadList: showUploadList,
            headers: {
                authorization: 'authorization-text',
            },
            onChange(info) {
                self.setState({
                    showUploadList: true,
                });
                if (info.file.status === 'done') {
                    message.success(`${info.file.name} 上传成功`);
                    // console.log(info);
                    self.setState({
                        showUploadList: false,
                        headImgUrl: config.server + info.file.response.data.filePath
                    });
                } else if (info.file.status === 'error') {
                    message.error(`${info.file.name} 上传失败`);
                    self.setState({
                        showUploadList: false
                    });
                }
            },
        };

        let buttonsHtml = '';

        if (editMode) {
            buttonsHtml = (
                <div>
                    <Button onClick={this.save}>保存</Button>
                    <Button onClick={this.back}>返回</Button>
                </div>
            );
        } else {
            buttonsHtml = (
                <div>
                    <Button onClick={this.showEditTelModal}>修改手机号码</Button>
                    <Button onClick={this.showEditPasswordModal}>修改密码</Button>
                    <Button onClick={this.edit}>编辑</Button>
                </div>
            );
        }

        return (

            <div className='dms-body'>
                <div>
                    <DmsTab options={opts} defaultKey={0}>
                        {buttonsHtml}
                    </DmsTab>
                </div>

                <div className="dms-table-box">
                    <Form onSubmit={this.handleSubmit}>
                        <FormItem
                            {...formItemLayout}
                            label="头像"
                        >{
                            disabledFlag ? (headImgUrl ?
                                    <img src={headImgUrl} style={{width: '50px', height: '50px', borderRadius: '100%'}}/> :
                                    <Avatar style={{width: '50px', height: '50px', borderRadius: '100%'}} size="large"
                                            icon="user"/>) :
                                <Upload {...props}>{headImgUrl ?
                                    <img src={headImgUrl}
                                         style={{width: '50px', height: '50px', borderRadius: '100%'}}/> :
                                    <Avatar style={{width: '50px', height: '50px', borderRadius: '100%'}}
                                            size="large"
                                            icon="user"/>}
                                    <span style={{position: 'relative', top: '-20px'}}>点击头像上传</span>
                                </Upload>
                        }
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="姓名"
                        >
                            <span>{profile.name ? profile.name : ''}</span>
                        </FormItem>
                        {/*<FormItem
                            {...formItemLayout}
                            label="性别"
                        >
                            <span>{profile.sex == 1 ? '男' : '女'}</span>
                        </FormItem>*/}
                        <FormItem
                            {...formItemLayout}
                            label="用户名"
                        >
                            <span>{profile.account ? profile.account : ''}</span>
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="手机号"
                        >
                            <span>{profile.phone ? profile.phone : ''}</span>
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="座机"
                        >
                            {getFieldDecorator('tel', {
                                initialValue: profile.tel ? profile.tel : '',
                                rules: [{message: '请输入座机号！', whitespace: true}],
                            })(
                                <Input disabled={disabledFlag}/>
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="邮箱"
                        >
                            {getFieldDecorator('email', {
                                initialValue: profile.email ? profile.email : '',
                                rules: [{message: '请输入邮箱！', whitespace: true}],
                            })(
                                <Input disabled={disabledFlag}/>
                            )}
                        </FormItem>
                        <Collapse>
                            <Panel header="事物管理设置" key="1">
                                <FormItem
                                    {...formItemLayout}
                                    label="金额小数位"
                                >
                                    {getFieldDecorator('amountDecimalPlace', {
                                        initialValue: profile.amountDecimalPlace ? profile.amountDecimalPlace : '',
                                        rules: [{message: '请选择！', whitespace: true}],
                                    })(
                                        <Select disabled={disabledFlag}>
                                            <Option value="0">0</Option>
                                            <Option value="1">1</Option>
                                            <Option value="2">2</Option>
                                            <Option value="3">3</Option>
                                            <Option value="4">4</Option>
                                        </Select>
                                    )}
                                </FormItem>
                                <FormItem
                                    {...formItemLayout}
                                    label="价格小数位"
                                >
                                    {getFieldDecorator('priceDecimalPlace', {
                                        initialValue: profile.priceDecimalPlace ? profile.priceDecimalPlace : '',
                                        rules: [{message: '请选择！', whitespace: true}],
                                    })(
                                        <Select disabled={disabledFlag}>
                                            <Option value="0">0</Option>
                                            <Option value="1">1</Option>
                                            <Option value="2">2</Option>
                                            <Option value="3">3</Option>
                                            <Option value="4">4</Option>
                                            <Option value="5">5</Option>
                                            <Option value="6">6</Option>
                                        </Select>
                                    )}
                                </FormItem>
                                <FormItem
                                    {...formItemLayout}
                                    label="数量小数位"
                                >
                                    {getFieldDecorator('countDecimalPlace', {
                                        initialValue: profile.countDecimalPlace ? profile.countDecimalPlace : '',
                                        rules: [{message: '请选择！', whitespace: true}],
                                    })(
                                        <Select disabled={disabledFlag}>
                                            <Option value="0">0</Option>
                                            <Option value="1">1</Option>
                                            <Option value="2">2</Option>
                                            <Option value="3">3</Option>
                                            <Option value="4">4</Option>
                                        </Select>
                                    )}
                                </FormItem>
                                <FormItem
                                    {...formItemLayout}
                                    label="默认订单类型"
                                >
                                    {getFieldDecorator('orderType', {
                                        initialValue: profile.orderType ? profile.orderType : '',
                                        rules: [{message: '请选择！', whitespace: true}],
                                    })(
                                        <Select disabled={disabledFlag}>
                                            <Option value="1">销售出库</Option>
                                            <Option value="2">零售单</Option>
                                            <Option value="3">退货单</Option>
                                        </Select>
                                    )}
                                </FormItem>
                                <FormItem
                                    {...formItemLayout}
                                    label="默认付款条件"
                                >
                                    {getFieldDecorator('payType', {
                                        initialValue: profile.payType ? profile.payType : '',
                                        rules: [{message: '请选择！', whitespace: true}],
                                    })(
                                        <Select disabled={disabledFlag}>
                                            <Option value='现金'>现金</Option>
                                            <Option value='欠款'>欠款</Option>
                                            <Option value='代收'>代收</Option>
                                            <Option value='月结'>月结</Option>
                                            <Option value='银行'>银行</Option>
                                            <Option value='转账'>转账</Option>
                                            <Option value='支付宝'>支付宝</Option>
                                            <Option value='微信'>微信</Option>
                                        </Select>
                                    )}
                                </FormItem>
                                <FormItem
                                    {...formItemLayout}
                                    label="查询物料结果"
                                >
                                    {getFieldDecorator('sortRules', {
                                        initialValue: profile.sortRules ? profile.sortRules : ''
                                    })(
                                        <CheckboxGroup options={options} disabled={disabledFlag}/>
                                    )}
                                </FormItem>
                                {/*暂时不启用*/}
                                {/*<FormItem*/}
                                {/*    {...formItemLayout}*/}
                                {/*    label="录入重复物料"*/}
                                {/*>*/}
                                {/*    {getFieldDecorator('orderMultiLine', {*/}
                                {/*        initialValue: profile.orderMultiLine ? profile.orderMultiLine : '',*/}
                                {/*        rules: [{message: '请选择！', whitespace: true}],*/}
                                {/*    })(*/}
                                {/*        <Select disabled={disabledFlag}>*/}
                                {/*            <Option value="0">否</Option>*/}
                                {/*            <Option value="1">是</Option>*/}
                                {/*        </Select>*/}
                                {/*    )}*/}
                                {/*</FormItem>*/}
                            </Panel></Collapse>
                    </Form>
                </div>

                <EditBindingTel
                    phone={profile.phone}
                    visible={visible}
                    handleOk={this.editTelModalHandleOk}
                    handleCancel={this.editTelModalHandleCancel}
                    form={this.props.form}
                >
                </EditBindingTel>

                <EditPassword
                    visible={visible2}
                    handleOk={this.editPasswordModalHandleOk}
                    handleCancel={this.editPasswordModalHandleCancel}
                    form={this.props.form}
                >
                </EditPassword>

            </div>

        );
    }
}

export default Form.create()(ProfileInfo);


// WEBPACK FOOTER //
// ./src/routes/profile/info.js